(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('sc3Change', sc3Change);

    sc3Change.$inject = ['$parse'];
    function sc3Change($parse) {
        return {
            restrict: 'A',
            link: link
        };

        function link(scope, element, attr) {
            var handler = $parse(attr.sc3Change, null, true);
            element.on('change', change);

            function change(e) {
                scope.$apply(callback);

                function callback() {
                    handler(scope, { $event: e });
                }
            }
        }
    }
})();
